import Paging from "./KrPaging.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrPaging = install(Paging); // 生成带有 install 方法的组件

export default KrPaging;
